import React, {PropTypes,Component} from 'react';
import './style.less';
import mobx from 'mobx';
import {observer} from "mobx-react";
import {Ticon} from '../../../../../index';
import tools from '../../../../../utils/tools';



@observer
export default class RefList extends Component {

  state = {}

  constructor(props) {
    super(props);
  }

  handleSelect = (e, it) => {
    tools.preventEvent(e);
    this.props.onSelected(it.value);
  }

  render() {
    const {
      items = [],
      onSelected,
      searchValue,
      localSearch,
      rowID
    } = this.props;
    return (
      <div className='refList'>
        {items.length<=0?<div>没有找到任何数据</div>:null}
          {items.map((it,i)=>{
            return (
            <div key={i} 
              style={{display:(localSearch&&searchValue&&it.name.indexOf(searchValue)==-1)?'none':'block'}} 
              onClick={(e)=>this.handleSelect(e,it)}>
              <div>
                {tools.isArray(it.name)?it.name.join('/'):it.name + ((it.value && it.value.Version)?(' ('+it.value.Version+')'):'')}
              </div>
              <Ticon type='gouxuan' style={{visibility: it.selected?'visible':'hidden', float: 'right'}}/>
            </div>);
          })}
      </div>
    )
  }

}
